import { render, staticRenderFns } from "./AndroidGuide.vue?vue&type=template&id=0bd3214a&scoped=true"
import script from "./AndroidGuide.vue?vue&type=script&lang=js"
export * from "./AndroidGuide.vue?vue&type=script&lang=js"
import style0 from "./AndroidGuide.vue?vue&type=style&index=0&id=0bd3214a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd3214a",
  null
  
)

export default component.exports